module.exports = __webpack_public_path__ + "static/media/s1-alt.5e0bf20b.png";